// the host url of the backend apis
const BASE_URL = process.env.REACT_APP_BACKEND_API_BASE_URL;

// the current version of the apis
const VERSION = process.env.REACT_APP_BACKEND_API_VERSION;

// service urls for backed apis
export const serviceUrls = {
  ADMIN_SERVICE: BASE_URL + "/admin/" + VERSION,
  HOSTEL_SERVICE: BASE_URL + "/hostel/" + VERSION,
  LIBRARY_SERVICE: BASE_URL + "/library/" + VERSION,
  LICENSE_SERVICE: BASE_URL + "/license/" + VERSION,
  TRANSPORT_SERVICE: BASE_URL + "/transport/" + VERSION,
  ACADEMIC_SERVICE: BASE_URL + "/academic/" + VERSION,
  CANTEEN_SERVICE: BASE_URL + "/canteen/" + VERSION,
  EXAMINATION_SERVICE: BASE_URL + "/examination/" + VERSION,
  FEE_MANAGEMENT_SERVICE: BASE_URL + "/feemanagement/" + VERSION,
  FORMS_SERVICE: BASE_URL + "/forms/" + VERSION,
  PARKING_SERVICE: BASE_URL + "/parking/" + VERSION,
  APPROVE_SERVICE: BASE_URL + "/approval/" + VERSION,
  STUDENT_SERVICE: BASE_URL + "/student/" + VERSION,
};

export const formFieldsData = {
  firstName: {
    label: "First Name",
    type: "text",
    required: true,
  },
  organizationId: {
    label: "Organization",
    type: "text",
    required: true,
  },
  lastName: {
    label: "Last Name",
    type: "text",
    required: true,
  },
  email: {
    label: "Email",
    type: "email",
    required: true,
  },
  phone: {
    label: "Phone",
    type: "text",
    required: true,
  },
  password: {
    label: "Password",
    type: "password",
    required: true,
  },
  department: {
    label: "Department",
    type: "text",
    required: true,
  },
  regionId: {
    label: "Region",
    type: "text",
    required: true,
  },
  siteId: {
    label: "Site",
    type: "text",
    required: true,
  },
  addressline1: {
    label: "Address Line 1",
    type: "text",
    required: true,
  },
  addressline2: {
    label: "Address Line 2",
    type: "text",
    required: true,
  },
  cityId: {
    label: "City",
    type: "text",
    required: true,
  },
  stateId: {
    label: "State",
    type: "text",
    required: true,
  },
  postalCode: {
    label: "Postal Code",
    type: "text",
    required: true,
  },
  countryId: {
    label: "Country",
    type: "text",
    required: true,
  },
  role: {
    label: "Role",
    type: "text",
    required: true,
  },
  roleId: {
    label: "Role",
    type: "text",
    required: true,
  },
  departmentId: {
    label: "Department",
    type: "text",
    required: true,
  },
  userMobile: {
    label: "Mobile",
    type: "text",
    required: true,
  },
  dob: {
    label: "Date of Birth",
    type: "date",
    required: true,
  },
  maritalStatus: { label: "Marital Status", type: "text", required: true },
  gender: { label: "Gender", type: "text", required: true },
};
export const pagePaths = {
  Users: {
    addForm: {
      label: "Add",
      path: "/organisation/users/user-add",
    },
    initialsAvatar: true,
    editForm: {
      label: "Edit User",
      path: "/users/update-user",
    },
    viewPage: {
      label: "view-user",
      path: "",
    },
  },
  Regions: {
    initialsAvatar: true,
    addForm: {
      label: "Add",
      path: "/regions",
    },
    editForm: {
      label: "Edit Region",
      path: "/regions",
    },
  },
  Departments: {
    initialsAvatar: true,
    addForm: {
      label: "Add",
      path: "/organisation/users/add-department",
    },
    editForm: {
      label: "Edit Department",
      path: "",
    },
    viewPage: {
      label: "view-department",
    },
  },
  Sites: {
    initialsAvatar: true,
    addForm: {
      label: "Add",
      path: "/organisation/add-sites",
    },
  },

  Hostel: {
    addForm: {
      label: "Add",
      path: "/organisation/hostel/hostel-add",
    },
    viewPage: {
      label: "hostel-details",
      path: "/organisation/hostel/:id/",
    },
  },

  Forms: {
    viewPage: {
      label: "view-form",
      path: "/organisation/forms/:id/",
    },
  },

  Rooms: {
    addForm: {
      label: "Add",
      path: "/organisation/hostel/add-room",
    },
    viewPage: {
      childId: "roomId",
      label: "room-details",
      path: "/organisation/hostel/rooms",
    },
  },

  "Room Facilities": {
    addForm: {
      label: "Add",
      path: "/organisation/hostel/add-room-facility",
    },
  },
  "Hostel Users": {
    viewPage: {
      label: "View",
      path: "/organisation/hostel/hostel-users",
    },
  },
  "User Guest": {
    viewPage: {
      label: "View",
    },
  },
  Guests: {
    viewPage: {
      label: "View",
    },
  },
  "Food Menu": {
    // addForm: {
    //   label: "Add",
    //   path: "/organisation/hostel/add-food-menu",
    // },
    viewPage: {
      childId: "foodMenuId",
      label: "meals",
      path: "",
    },
  },
  Meals: {
    // addForm: {
    //   label: "Add",
    //   path: "/organisation/hostel/add-food-menu",
    // },
    viewPage: {
      childId: "mealId",
      label: "meal-item",
      path: "",
    },
  },

  "Special Food Menu": {
    addForm: {
      label: "Add",
      path: "/organisation/hostel/add-food-menu",
    },
    viewPage: {
      childId: "foodMenuId",
      label: "View",
      path: "/organisation/hostel/food-menu",
    },
  },
  "Room Types": {
    addForm: {
      label: "Add",
      path: "/organisation/hostel/add-food-menu",
    },
  },

  // library here:

  Library: {
    addForm: {
      label: "Add",
      path: "/organisation/library/library-add",
    },
    viewPage: {
      label: "library-details",
      path: "/organisation/library/:id/",
    },
  },

  // transport here:
  Transport: {
    addForm: {
      label: "Add",
      path: "/organisation/transport/transport-add",
    },
    viewPage: {
      label: "transport-details",
      path: "/organisation/transport/:id/",
    },
  },

  Books: {
    addForm: {
      label: "Add",
      path: "/organisation/library/add-book",
    },
    viewPage: {
      label: "book-details",
      path: "/organisation/library/books",
    },
  },
  Groups: {
    addForm: {
      label: "Add",
    },
    viewPage: {
      label: "view-group",
      path: "/organisation/users/group-details",
    },
  },
  "Group Users": { initialsAvatar: true },
  Roles: {
    addForm: {
      label: "Add",
    },

    viewPage: {
      label: "view-role",
    },
  },
  Tutor: {
    initialsAvatar: true,
    viewPage: {
      label: "view-tutor",
    },
  },
  Subject: {
    viewPage: {
      label: "view-subject",
    },
  },
  Classes: {
    viewPage: {
      label: "view-class",
    },
  },
  "Division Sections": {
    viewPage: {
      label: "view-division-section",
    },
  },
  "Division Section Schedule": {
    viewPage: {
      label: "view-division-section-schedule",
    },
  },
  "Tutor Assignment": {
    viewPage: {
      label: "view-tutor-assignment",
    },
  },
  "Tutor Homework": {
    viewPage: {
      label: "view-tutor-homework",
    },
  },

  Templates: {
    viewPage: {
      label: "view-template",
    },
  },
  "Examination Series": {
    viewPage: {
      label: "view-series",
    },
  },
};

export const advanceFilterList = {
  region: false,

  site: false,
  status: false,
  date: false,
  department: false,
  role: false,
};
export const advanceFilterData = {
  date: {
    status: false,
    type: "AFTER",
    startDate: null,
    endDate: null,
  },
  region: {
    status: false,
    value: null,
    label: null,
  },
  site: {
    status: false,
    value: null,
    label: null,
  },
  status: {
    status: false,
    value: null,
  },
  department: {
    status: false,
    value: null,
    label: null,
  },
  role: {
    status: false,
    value: null,
    label: null,
  },
};
export const selectStyle = {
  control: (base, state) => ({
    ...base,
    minHeight: "48px",
    backgroundColor: "transparent !important",
    border: "none !important",
    borderBottom: state.isFocused
      ? "2px solid #8f8c8c !important"
      : "1px solid #ced4da !important",
    borderRadius: "0 !important",
    boxShadow: "none !important",
    paddingLeft: "0",
    paddingRight: "0",
    margin: "0 !important",
    "&:hover": {
      borderBottom: "2px solid #000 !important",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
  }),
  input: (base) => ({
    ...base,
    color: "#000 !important",
    padding: "0 !important",
    margin: "0 !important",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#000 !important",
    marginLeft: "0 !important",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0 !important",
    marginRight: "8px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 !important",
    color: "#000 !important",
    "&:hover": {
      color: "#000 !important",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "0 !important",
    marginTop: "4px !important",
    border: "1px solid #dee2e6 !important",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1) !important",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#0d6efd"
      : state.isFocused
      ? "#e9ecef"
      : null,
    color: state.isSelected ? "white" : "black",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
  }),
  loadingMessage: (base) => ({
    ...base,
    color: "#6c757d",
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: "#6c757d",
  }),
};
export const planColors = [
  // Vibrant Primary Colors
  "#4e73df",
  "#36b9cc",
  "#1cc88a",
  "#f6c23e",
  "#e74a3b",
  "#5a5c69",
  "#3a3b45",
  "#2e59d9",
  "#17a673",
  "#2c9faf",

  // Modern Pastels
  "#f8f9fc",
  "#e3e6f0",
  "#d1d3e2",
  "#b7b9cc",
  "#858796",
  "#6e707e",
  "#5a5c69",
  "#3a3b45",
  "#296192",
  "#1f4d73",

  // Gradient-friendly Colors
  "#4b6cb7",
  "#4e73df",
  "#5b86e5",
  "#6c8cd4",
  "#7ea3e0",
  "#93b5e1",
  "#a2c0eb",
  "#b7d3f3",
  "#cfe2f3",
  "#e2eaf7",

  // Warm Tones
  "#ff6b6b",
  "#ff8787",
  "#ffa8a8",
  "#ffc9c9",
  "#ffe3e3",
  "#f06595",
  "#f783ac",
  "#faa2c1",
  "#fcc2d7",
  "#ffe4f3",

  // Cool Tones
  "#74c0fc",
  "#91a7ff",
  "#748ffc",
  "#5c7cfa",
  "#4c6ef5",
  "#3b5bdb",
  "#364fc7",
  "#2f44ad",
  "#283a94",
  "#1f327d",

  // Nature-inspired
  "#8ce99a",
  "#69db7c",
  "#51cf66",
  "#40c057",
  "#37b24d",
  "#2f9e44",
  "#2b8a3e",
  "#237032",
  "#1b5929",
  "#14431f",

  // Premium Metals
  "#ffd43b",
  "#fcc419",
  "#fab005",
  "#f59f00",
  "#f08c00",
  "#e67700",
  "#d9480f",
  "#c92a2a",
  "#b02525",
  "#991b1b",

  // Deep Jewel Tones
  "#7950f2",
  "#6741d9",
  "#5f3dc4",
  "#5234ab",
  "#462d91",
  "#3b2678",
  "#31205f",
  "#28194a",
  "#1f1235",
  "#160b20",

  // Fresh Greens
  "#96f2d7",
  "#63e6be",
  "#38d9a9",
  "#20c997",
  "#12b886",
  "#0ca678",
  "#099268",
  "#087f5b",
  "#0c6b4d",
  "#0b573f",

  // Sophisticated Neutrals
  "#adb5bd",
  "#868e96",
  "#495057",
  "#343a40",
  "#212529",
  "#e9ecef",
  "#dee2e6",
  "#ced4da",
  "#f8f9fa",
  "#e9ecef",

  // Accent Colors
  "#d0bfff",
  "#b197fc",
  "#9775fa",
  "#845ef7",
  "#7950f2",
  "#7048e8",
  "#6741d9",
  "#5f3dc4",
  "#563dba",
  "#4d36b0",

  // Energetic Oranges
  "#ff922b",
  "#fd7e14",
  "#f76707",
  "#e8590c",
  "#d9480f",
  "#c2410c",
  "#ad3a09",
  "#983307",
  "#832b04",
  "#6e2400",

  // Soft Purples
  "#cc5de8",
  "#be4bdb",
  "#ae3ec9",
  "#9c36b5",
  "#8c2fa2",
  "#7d2990",
  "#6e227e",
  "#601c6c",
  "#52175a",
  "#441148",

  // Modern Gradients
  "#228be6",
  "#339af0",
  "#4dabf7",
  "#6bc0ff",
  "#8fd3ff",
  "#b3e0ff",
  "#d0ebff",
  "#e7f5ff",
  "#f3f9ff",
  "#f8fbff",
];
